import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classnames from "classnames";

import styles from "./styles.module.scss";

export type CheckboxGroupType = HtmlHTMLAttributes<HTMLDivElement>

export const CheckboxGroup = memo(forwardRef<HTMLDivElement, CheckboxGroupType>((
  {
    className,
    children,
    ...props
  }, ref) =>
  <div
    ref={ref}
    {...props}
    className={classnames(
      className,
      styles.root,
    )}
  >
    {children}
  </div>,
));